import PublicRouteGuard from 'main/utility/PublicRouteGuard';
import React from 'react';
import {BUSINESS_ROLE} from 'shared/constants/AppConst';

const Signin = React.lazy(() => import('./Signin'));
const EmailVerification = React.lazy(() => import('./EmailVerification'));
// const Signup = React.lazy(() => import('./Signup'));
// const ForgotPassword = React.lazy(() => import('./ForgetPassword'));
// const AdminProfile = React.lazy(() => import('./AdminProfile'));
// const NewMemberProfile = React.lazy(() => import('./NewMemberProfile'));

export const authRouteConfig = [
  {
    path: '/signin',
    element: (
      <PublicRouteGuard>
        <Signin />
      </PublicRouteGuard>
    ),
    permittedrole: BUSINESS_ROLE.PUBLIC,
  },
  {
    path: '/verify/:token',
    element: (
      <PublicRouteGuard>
        <EmailVerification />
      </PublicRouteGuard>
    ),
    permittedrole: BUSINESS_ROLE.PUBLIC,
  },
  // {
  //   path: '/signup',
  //   element: <Signup />, // TODO-SM: Self-signups are disabled for now
  // },
  // {
  //   path: '/forget-password',
  //   element: <ForgotPassword />,
  // },
];
